export default "__VITE_ASSET__C4folGL0__"